// extracted by mini-css-extract-plugin
export default {"icon":"components-hotel-benchmark-insight-upsell-icon-module__icon"};